import Icons from '@ecomm/shared-icons'
import classNames from 'classnames'

export type DetailBubbleTheme = 'dark' | 'light'

export type DetailBubbleProps = {
  readonly icon: Icons.IconTypes
  readonly text: string
}

type Props = DetailBubbleProps & { readonly theme: DetailBubbleTheme }

export function DetailBubble({ icon, text, theme }: Props) {
  const Icon = Icons[icon]
  return (
    <div
      className={classNames(
        'box-border flex min-h-[95px] min-w-[240px] max-w-[240px] items-center rounded-[20px] py-3 pr-3 font-semibold',
        {
          'bg-neutral-black text-white': theme === 'dark',
          'bg-neutral-light-50 text-neutral-black': theme === 'light'
        }
      )}
      data-component="DetailBubble"
    >
      <div className="m-2 mx-3 flex items-center justify-center">
        {icon ? <Icon className="h-10 w-10" /> : null}
      </div>
      <p className="m-0 p-0 text-sm">{text}</p>
    </div>
  )
}
